import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue'
import { debounce } from 'lodash'

/* eslint-disable */

export default /*@__PURE__*/_defineComponent({
  __name: 'RangeSingleWidget',
  props: {
  modelValue: {},
  filter: Object,
  resetTrigger: Boolean,
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const gcd = (a, b, onZero = 1) => (
  a < b
    ? gcd(b, a, onZero)
    : (
      b < 0.001 || isNaN(b) || isNaN(b)
        ? (0 === a ? onZero : a)
        : gcd(b, a - Math.floor(a / b) * b)
    )
)

const props = __props

const emit = __emit

const model = ref(props.filter.values.min || 0)

const interval = computed(() => {
  const { values } = props.filter
  const v = parseFloat(gcd(Math.abs(values.min), Math.abs(values.max)).toFixed(2))

  return v > 1 ? 1 : v
})

const update = () => {
  const { values } = props.filter

  const val = Number(model.value)
  const minRangeAsDefault = val === values.min

  if (minRangeAsDefault) {
    emit('update:modelValue', null)
  } else {
    emit('update:modelValue', model.value)
  }
}

const normalizeValue = (val: any) => {
  const { values } = props.filter

  return val || values.min
}

const setValueFromUrl = (val: any) => {
  const normalizedValue = normalizeValue(val)

  model.value = normalizedValue
}

const debounceUpdate = debounce(update, 800)

watch(() => props.modelValue, () => {
  setValueFromUrl(props.modelValue)
}, { immediate: true })

watch(() => props.resetTrigger, () => {
  normalizeValue(null)
})

const __returned__ = { gcd, props, emit, model, interval, update, normalizeValue, setValueFromUrl, debounceUpdate, ref, watch, computed, get debounce() { return debounce } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})